import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import goccia from "../../Assets/Projects/gocciago.png";
import quoter from "../../Assets/Projects/quoter.png";
import { useLang } from "../../context/LanguageContext";
import { translations } from "../../translations";

const imgPaths = [goccia, quoter, undefined, undefined, undefined, undefined];
const demoLinks = [
  "https://gocciago-website.vercel.app/",
  "https://quotareader.devlabspace-mat.com/",
  "https://github.com/mattemile/app_supabase_api",
  "https://github.com/mattemile/fullstack_kafka_repo_public",
  "https://github.com/mattemile/LLM-locale",
  "https://github.com/mattemile/ChatbotPDF-LLM",
];
const stacks = [undefined, undefined, undefined, undefined, undefined, undefined];
const linkTypes = ["demo", "demo", "github", "github", "github", "github"];

function Projects() {
  const { lang } = useLang();
  const tr = translations[lang].projects;

  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          {tr.myRecent} <strong className="purple">{tr.works} </strong>
        </h1>
        <p style={{ color: "white" }}>{tr.subtitle}</p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          {tr.items.map((project, i) => (
            <Col key={i} md={4} className="project-card">
              <ProjectCard
                imgPath={imgPaths[i]}
                isBlog={false}
                title={project.title}
                description={project.description}
                demoLink={demoLinks[i]}
                stack={stacks[i]}
                linkType={linkTypes[i]}
              />
            </Col>
          ))}
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
